import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { TradingPanel } from "../trading/Panel";
import { TC, TvChart } from "../trading/TvChart";
import { mon, pc, Que } from "./ui";

const val = (r, m) => (r.fmt === "pct" ? pc(r.valor) : r.fmt === "fx" ? (r.valor ? r.valor.toFixed(4) : "Sin FIX") : r.fmt === "txt" ? r.valor : mon(r.valor, m));

export const BaseTabla = ({ r }) => (
  <div className="overflow-x-auto"><table className="w-full min-w-[460px] text-sm" data-testid="bb-tabla"><tbody>
    {r.tabla.map((x, i) => <tr key={i} className={`border-t border-[#F2F0EC] ${x.total ? "bg-[#F7F5F1] font-bold text-[#0B2545]" : ""}`} data-testid={`bb-fila-${i}`}>
      <td className="py-2 pl-2 pr-3"><span className="inline-flex items-center gap-1">{x.concepto}<Que t={<><b>¿Cómo se calculó?</b> {x.como}</>} testid={`bb-como-${i}`} /></span></td>
      <td className={`py-2 pr-2 text-right tabular-nums ${typeof x.valor === "number" && x.valor < 0 && x.fmt !== "fx" ? "text-rose-700" : ""}`}>{val(x, r.moneda)}</td></tr>)}
  </tbody></table></div>
);

export const Historico = ({ lid, moneda }) => {
  const [h, setH] = useState(null);
  useEffect(() => { http.get(`/fondeo/lineas/${lid}/historial`).then((x) => setH(x.data.filter((s) => s.estado === "Calculado"))); }, [lid]);
  if (!h) return null;
  if (!h.length) return <p className="rounded-2xl border border-dashed border-[#E2DDD5] p-6 text-center text-sm text-[#8C867A]" data-testid="bb-historico-vacio">El histórico se llena con el cálculo diario de las 07:15 una vez configurada la línea.</p>;
  const pt = (k) => h.map((s) => ({ time: s.fecha, value: s[k] ?? 0 }));
  return (
    <TradingPanel title="Excedente / (déficit) histórico" testid="bb-historico" ultimo={mon(h[h.length - 1].excedente, moneda)} tono={h[h.length - 1].excedente >= 0 ? "good" : "bad"}
      como="Un punto por día (cálculo de las 07:15 y recálculos): base de préstamo descontada − saldo dispuesto con los acreditantes." fuente="Fondeo · fondeo_bb">
      <TvChart height={240} fmt={(v) => mon(v, moneda)} testid="bb-historico-chart"
        series={[{ id: "exc", name: "Excedente", type: "histogram", color: TC.up, data: h.map((s) => ({ time: s.fecha, value: s.excedente ?? 0, color: (s.excedente ?? 0) < 0 ? TC.down : TC.up })) },
          { id: "dbb", name: "BB descontada", type: "line", color: TC.accent, data: pt("dbb") }, { id: "disp", name: "Dispuesto", type: "line", color: TC.blue, data: pt("dispuesto") }]} />
    </TradingPanel>
  );
};
